export const userConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    FORGOTPASSWORD_REQUEST: 'FORGOTPASSWORD_REQUEST',
    FORGOTPASSWORD_SUCCESS: 'FORGOTPASSWORD_SUCCESS',
    FORGOTPASSWORD_FAILURE: 'FORGOTPASSWORD_FAILURE',
    
    LOGOUT: 'USERS_LOGOUT',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE',
    IS_FILE_UPLOAD: 1,
    // Constant values for role_id column
    DONOR: 2,
    FUNDRAISER: 2,
    DONOR_FUNDRAISER: 2,
    PARTNER: 3,

    // GENERAL CONSTANTS
    DASHBOARD_TAB        : 1,
    TEAM_FUNDRAISERS_TAB : 2,
    FUNDRAISERS_TAB      : 3,
    DONATION_HISTROY_TAB : 4,
    SETTINGS_TAB         : 5,
    // _SETTINGS_TAB         : 6,
    // PAST_FUNDRAISERS_TAB : 6,
    // TEAMS_TAB            : 7,

    GTM_ENABLED : 1,

};
